import React from 'react';
import styled from 'styled-components';
import { SectionParent, B1, H1, H2, BlueButton } from '../../StyledComponents';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Kiosk from '../../../assets/v2/AboutUs/kioskAbout.png';
import { navigate } from 'gatsby';

const Section = styled(SectionParent)`
  background: #ffffff;
  padding-top: 1rem !important;
  padding-bottom: 0rem !important;
  @media (max-width: 520px) {
    padding-top: 1rem !important;
    padding-bottom: 0rem !important;
  }
`;
const Grid = styled.div`
  display: grid;
  padding-bottom: 3rem;
  padding-top: 2rem;
  grid-template-columns: repeat(4, 1fr);
  @media (max-width: 768px) {
    grid-template-columns: repeat(4, 1fr);
  }
  @media (max-width: 700px) {
    grid-template-columns: repeat(3, 1fr);
  }
`;
const GridItem = styled.div`
  justify-self: center;
  max-width: 60%;
  grid-column: span 4;
  @media (max-width: 768px) {
    margin-right: 0rem;
  }
  /* @media (max-width: 700px) {
    grid-column: span 3;
    margin-bottom: 3rem;
    display: grid;
    margin-right: 0rem;
    justify-items: center;
  } */
  @media (max-width: 520px) {
    max-width: 90%;
  }
`;
const SectionContent = styled(B1)`
  font-family: 'Nunito Sans', sans-serif;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.61;
  letter-spacing: normal;
  width: 100%;
  color: #626679;
  padding-top: 0.5rem;
  text-align: justify;
  img {
    margin-top: 1rem;
  }
  /* @media (max-width: 700px) {
    padding-left: 0;
    text-align: justify;
    width: 90%;
  }
  @media (max-width: 520px) {
    width: 120%;
    text-align: center;
  } */
`;
const SectionTitle = styled(H1)`
  @media (max-width: 520px) {
    text-align: center;
  }

  font-weight: bold;
  font-family: 'Nunito Sans', sans-serif;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.92;
  letter-spacing: normal;
  color: #151828;
`;

const SectionTopTitle = styled(H2)`
  color: #151828;
  font-family: 'Nunito Sans', sans-serif;
  font-weight: bold;
`;

const TargetImage = styled(LazyLoadImage)`
  width: 100%;
  margin: 2rem 0;
  justify-self: center;
`;
const ImgWrapper = styled.div`
  display: grid;
  align-items: center;
  grid-column: span 4;
  @media (max-width: 768px) {
    grid-column: span 4;
  }
  @media (max-width: 700px) {
    grid-column: span 3;
  }
  @media (max-width: 520px) {
    padding-bottom: 2rem;
  }
`;
const SecondSection = styled.div`
  padding: 2rem 4rem;
  background: linear-gradient(76deg, #1b224e 13%, #181e43 90%);
  justify-content: center;
  @media (max-width: 520px) {
    display: grid;
    padding: 1rem;
  }
`;
const SecondText = styled(H2)`
  color: white;
  text-align: center;
  align-self: center;
  padding-right: 1rem;
  font-weight: bold;
  font-family: 'Nunito Sans', sans-serif;
  @media (max-width: 520px) {
    padding: 0 2rem;
    padding-bottom: 1rem;
  }
  @media (max-width: 350px) {
    padding: 0 1rem;
  }
`;
const BlueButtonWrapper = styled.div`
  /* margin-left: -10px; */
  margin-top: 1rem;
  display: grid;
  justify-content: center;
  @media (max-width: 768px) {
    text-align: center;
  }
`;
const BlueButtonNew = styled(BlueButton)`
  border-radius: 23px;
`;
export default ({ messages }: any) => (
  <div>
    <Section>
      <Grid>
        <GridItem>
          <SectionTopTitle>{messages?.AboutUsPageStoryTitle}</SectionTopTitle>
          <SectionTitle>{messages?.AboutUsPageStoryTitle2}</SectionTitle>
          <SectionContent> {messages?.AboutUsPageStoryDesc1}</SectionContent>
          <ImgWrapper>
            <TargetImage src={Kiosk} />
          </ImgWrapper>
          <SectionContent>
            {messages?.AboutUsPageStoryDesc2}
            <br />
            <br />
            {messages?.AboutUsPageStoryDesc3}
          </SectionContent>
        </GridItem>
      </Grid>
    </Section>
    <SecondSection>
      <SecondText>
        {messages?.AboutUsPageCTAText1}

        <br />
        {messages?.AboutUsPageCTAText2}
      </SecondText>
      <BlueButtonWrapper>
        <BlueButtonNew
          id="about_us__get_in_touch"
          onClick={() =>
            navigate(
              messages?.locale !== 'en'
                ? `/${messages?.locale}/contact-us`
                : '/contact-us'
            )
          }
        >
          {messages?.AboutUsPageCTAGetInTouch}
        </BlueButtonNew>
      </BlueButtonWrapper>
    </SecondSection>
  </div>
);
